import { getTimeZoneData } from '@bimser/core';
import dayjs from 'dayjs';

class DateHelper {
	createDate(args?: Date): string {
		if (args) {
			return dayjs(new Date(args)).format();
		}
		return dayjs().format();
	}

	getTimeZone() {
		return getTimeZoneData();
	}
}

export default class TSHelper {
	static date = new DateHelper();
}
